export default __webpack_public_path__ + "static/media/website-gif.def9ac53.gif";